import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { Location } from "../..";

enum InvoiceType {
    SOLD = "sold",
    BOUGHT = "bought",
    INCOME = "income",
    COST = "cost",
    RETURN_FROM_SOLD = "rs",
    RETURN_FROM_BOUGHT = "rb",
    TRANSFER = "transfer"
}
enum TransactionUserType {
    CUSTOMER = "0",
    USER = "1"
}

enum DeliveryType {
    INSTANCE_DOOR = 0,
    CUSTOMER_DOOR = 1,
    THIRD_PERSON = 2
}
enum DeliveryStatus {
    IN_INVENTORY = 0,
    SENDING = 1,
    SENT = 2,
    DELIVERED = 3,
    RETURNED = 4
}

class TransactionOption {
    id: string;
    category_filter_id: string;
}

class InvoiceTransaction {
    name: string;
    count: number;
    value: number;
    value_without_off: number = null;
    price_id: string;
    creator_type: TransactionUserType;
    creator_id: string;
    inventory_id: string = null;
    options: TransactionOption[];
    product_id: string;
    type: InvoiceType.BOUGHT = InvoiceType.BOUGHT;
    max?: number;
}
class Payment {
    Amount = 0;
    paid = false;
    date_paid: Date= null;
}

class DeliveryAddress {
    location: any;
    position: any;
    phone: string;
    mobile: string;
    postcode: string;
    receiver_name: string;
    id_card: string;
}

class InvoiceDelivery {
    id: string;
    address: DeliveryAddress;
    status: DeliveryStatus = DeliveryStatus.DELIVERED;
    total = 0;
    type: DeliveryType = DeliveryType.INSTANCE_DOOR;
    method: DeliveryType;
}

export class Image {
    id?: string;
    url: string;
    alt: string;
}

class InvoiceCustomer {
    id: string;
    name: string;
    blocked: boolean;
    avatar: Image;
}

class Dates {
    created: Date;
    updated: Date;
    deleted: Date;
}

export class GetInvoiceResponse {
    id: string;
    title: string;
    type: InvoiceType;
    total: number;
    transactions: InvoiceTransaction[];
    payment: Payment;
    delivery: InvoiceDelivery;
    draft: boolean;
    customer: InvoiceCustomer;
    customer_id?: string;
    related_to_id?: string;
    relateds: GetInvoiceResponse[] = [];
    date: Dates;
}

export function getInvoice(instance_id: number, invoice_id: string): Promise<AxiosResponse<GetInvoiceResponse>> {
    const path = `/instance/${instance_id}/invoice/${invoice_id}`;
    return Cirus.get(path);
}